 
import React from 'react';
import { TFeature } from 'services/constants';
import NavMenuItem from '../../NavMenuItem/NavMenuItem';
import { MenuItemConfig, SubsectionConfig } from '../../../types';

export interface MenuSectionProps {
    title: string;
    subsections?: SubsectionConfig[];
    items?: MenuItemConfig[];
    hasBorder?: boolean;
    toggleActivePopover: (feature: TFeature) => void;
    activePopover: TFeature | null;
}

const MenuSection: React.FC<MenuSectionProps> = ({
    title,
    subsections = [],
    items = [],
    hasBorder = true,
    toggleActivePopover,
    activePopover,
}) => {
    const borderClass = hasBorder ? 'NSNavbar__dropdown_menu--subsection_border_bottom' : '';
    const hasSubsections = subsections.length > 0;
    const hasDirectItems = items.length > 0;

    return (
        <div className={`${borderClass}`}>
            <div className="pb-0">
                <h6 className="mt-2 text-uppercase text-dark ml-3">
                    {title}
                </h6>
            </div>

            {hasSubsections && (
                <>
                    {subsections.map((subsection, index) => {
                        const isLastSubsection = index === subsections.length - 1;
                        const showTitle = subsection.showTitle !== false;

                        return (
                            // eslint-disable-next-line react/no-array-index-key
                            <div key={`subsection-${index}`} className={isLastSubsection ? 'mb-1' : ''}>
                                {showTitle && (
                                    <h6 className="mt-2 text-uppercase text-muted ml-3">
                                        {subsection.title}
                                    </h6>
                                )}
                                <div className="ml-2">
                                    {subsection.items.map((item, itemIndex) => (
                                        <NavMenuItem
                                            // eslint-disable-next-line react/no-array-index-key
                                            key={`item-${index}-${itemIndex}`}
                                            label={item.label}
                                            url={item.url}
                                            feature={item.feature}
                                            toggleActivePopover={toggleActivePopover}
                                            activePopover={activePopover}
                                            enterpriseRequired={item.enterpriseRequired}
                                        />
                                    ))}
                                </div>
                            </div>
                        );
                    })}
                </>
            )}

            {hasDirectItems && (
                <div className="mb-1">
                    {items.map((item, index) => (
                        <NavMenuItem
                            // eslint-disable-next-line react/no-array-index-key
                            key={`direct-item-${index}`}
                            label={item.label}
                            url={item.url}
                            feature={item.feature}
                            toggleActivePopover={toggleActivePopover}
                            activePopover={activePopover}
                            enterpriseRequired={item.enterpriseRequired}
                        />
                    ))}
                </div>
            )}
        </div>
    );
};

export default MenuSection;
